module.exports = __webpack_public_path__ + "static/media/cifar1.7d34c260.png";